import { initializeParameterCollection } from './parameterCollection';

export const initializeParameters = () => {
  initializeParameterCollection();
};
